import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { FrontendHeaderComponent } from './frontend-header.component';
import { LocationSwitcherModule } from '@tablesready/frontend-location-switcher';
import { ThemeSwitchModule } from '@tablesready/frontend-theme-switch';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { SidebarModule } from '@tablesready/frontend-nav-sidebar';
import { FrontendTripleDotsModule } from '@tablesready/frontend-triple-dots';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendPaidFeatureModule } from '@tablesready/frontend-paid-feature-alert';

@NgModule({
  declarations: [FrontendHeaderComponent],
  imports: [
    CommonModule,
    IonicModule,
    ThemeSwitchModule,
    LocationSwitcherModule,
    StatusModule,
    AlertsModule,
    SidebarModule,
    FrontendTripleDotsModule,
    FrontendIconsModule,
    FrontendPaidFeatureModule,
  ],
  exports: [FrontendHeaderComponent],
})
export class FrontendHeaderModule {}
